<template>
  <Select
    :model-value="countryCode"
    :options="options"
    option-label="label"
    option-value="value"
    filter
    :placeholder="placeholder"
    aria-label="Your country"
    class="min-w-[11rem]"
    data-testid="landing-country-picker"
    @update:model-value="onChange"
  >
    <template #value="{ value }">
      <span class="flex items-center gap-2 text-sm">
        <span aria-hidden="true">{{ value ? countryFlag(value) : '🌍' }}</span>
        <span>{{ value ? countryName(value) : placeholder }}</span>
      </span>
    </template>
  </Select>
</template>

<script setup lang="ts">
import { useLandingCountry } from '@/composables/landing/useLandingCountry';
import { countryFlag, countryName, countryOptions } from '@/utils/landing/countryProfiles';

const { countryCode, setCountry } = useLandingCountry();
const placeholder = 'Choose country';
const options = computed(() => countryOptions(countryCode.value));

function onChange(code: string | null) {
  if (code) setCountry(code);
}
</script>
